import Icon from 'veui/components/Icon'

Icon.register({
  minus: {
    paths: [
      {
        d: 'M4 26a2 2 0 110-4h40a2 2 0 110 4H4z'
      }
    ],
    width: '48',
    height: '48'
  }
})
